import { render, staticRenderFns } from "./ExportBtn.vue?vue&type=template&id=12b22701&"
import script from "./ExportBtn.vue?vue&type=script&lang=js&"
export * from "./ExportBtn.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports